<div class="tpl-picker">
  <label class="form-label">Primeira mensagem — template aprovado (Meta)</label>

  <app-skeleton *ngIf="loading" variant="text" [count]="1"
    label="Carregando os templates aprovados" data-testid="whatsapp-template-loading"></app-skeleton>

  <div class="tpl-warning" *ngIf="!loading && !approvedTemplates.length">
    Nenhum template aprovado disponível.
    <span *ngIf="!metaConnected">Conecte a conta em <strong>WhatsApp → Integração WhatsApp</strong>.</span>
    <span *ngIf="metaConnected">Crie um em <strong>WhatsApp → Integração WhatsApp → Templates</strong>.</span>
  </div>

  <select class="form-control"
          *ngIf="!loading && approvedTemplates.length"
          [(ngModel)]="templateName"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onTemplateChange()"
          data-testid="select-whatsapp-template">
    <option [ngValue]="null">Selecione o template...</option>
    <option *ngFor="let tpl of approvedTemplates" [ngValue]="tpl.name">{{ tpl.name }}</option>
  </select>

  <div class="tpl-preview" *ngIf="templateName && selectedBody">{{ selectedBody }}</div>

  <div class="tpl-vars" *ngIf="templateName && placeholderIndexes.length">
    <span class="hint">
      Preencha cada variável do template com um dado do lead. A Meta recusa variável em
      branco: lead que não tiver o dado escolhido não recebe esta mensagem, e o motivo
      aparece na timeline dele.
    </span>
    <div class="tpl-var" *ngFor="let i of placeholderIndexes">
      <label class="tpl-var-label">{{ '{{' }}{{ i + 1 }}{{ '}}' }}</label>
      <select class="form-control"
              [(ngModel)]="templateVariables[i]"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onVariableChange()"
              [attr.data-testid]="'select-whatsapp-template-var-' + i">
        <option [ngValue]="''">Selecione o dado do lead...</option>
        <option *ngFor="let variable of leadVariables" [ngValue]="variable.token">{{ variable.label }}</option>
      </select>
    </div>
  </div>
</div>
